import type { MessageData } from '@fluenceur/types';
import { MessageTypeEnum } from '@fluenceur/types';
import React from 'react';
import AttachmentMessage from './AttachmentMessage';
import EmailMessage from './EmailMessage';
import InvitationMessage from './InvitationMessage';
import MentionMessage from './MentionMessage';
import TextMessage from './TextMessage';

export interface MessageProps {
  message: MessageData;
  isSelf: boolean;
  time?: string;
  groupPosition?: 'single' | 'first' | 'middle' | 'last';
}

/**
 * Factory component that selects the appropriate message renderer
 * based on the message type.
 */
const RenderMessageFactory: React.FC<MessageProps> = ({ message, isSelf, time, groupPosition }) => {
  // Select component based on message type
  switch (message.type) {
    case MessageTypeEnum.INVITATION:
      return <InvitationMessage message={message} time={time || ''} />;

    case MessageTypeEnum.EMAIL:
      return <EmailMessage message={message} time={time || ''} groupPosition={groupPosition} />;

    case MessageTypeEnum.STORY_MENTION:
    case MessageTypeEnum.CAPTION_MENTION:
      return <MentionMessage message={message} time={time || ''} />;

    case MessageTypeEnum.ATTACHMENT:
      return <AttachmentMessage message={message} time={time || ''} />;

    case MessageTypeEnum.TEXT:
    default:
      return (
        <TextMessage
          message={message}
          time={time || ''}
          isSelf={isSelf}
          groupPosition={groupPosition}
        />
      );
  }
};

export default RenderMessageFactory;
